// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"23cc186e","710":"c6cdbf96","845":"b81d6dbf"}[chunkId] + ".chunk.js";
};